import React from 'react';
export function TermsAndConditions() {
  return <div className="prose prose-sm max-w-none" data-id="element-1271">
      <p className="text-gray-600 mb-4" data-id="element-1272">
        <strong data-id="element-1273">Última actualización:</strong> Enero
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1274">1. Aceptación de Términos</h3>
      <p className="text-gray-700 mb-4" data-id="element-1275">
        Al comprar y utilizar el Sistema 50 Recetas Express, aceptas estos
        términos y condiciones. Si no estás de acuerdo, por favor no utilices
        nuestro producto.
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1276">
        2. Descripción del Producto
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-1277">
        El Sistema 50 Recetas Express es un producto digital que incluye:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-1278">
        <li data-id="element-1279">120+ recetas de 15 minutos en formato PDF</li>
        <li data-id="element-1280">12 menús semanales completos</li>
        <li data-id="element-1281">Guía de Batch Cooking Express</li>
        <li data-id="element-1282">Listas de compras imprimibles</li>
        <li data-id="element-1283">Guía de swaps por país</li>
        <li data-id="element-1284">Acceso a comunidad privada</li>
        <li data-id="element-1285">Actualizaciones mensuales</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1286">3. Licencia de Uso</h3>
      <p className="text-gray-700 mb-4" data-id="element-1287">
        Al comprar el sistema, obtienes una licencia personal y no transferible
        para:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-1288">
        <li data-id="element-1289">Usar el contenido para tu uso personal y familiar</li>
        <li data-id="element-1290">Imprimir las recetas para uso doméstico</li>
        <li data-id="element-1291">Acceder a las actualizaciones incluidas</li>
      </ul>
      <p className="text-gray-700 mb-4" data-id="element-1292">
        <strong data-id="element-1293">NO está permitido:</strong>
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-1294">
        <li data-id="element-1295">Compartir, revender o distribuir el contenido</li>
        <li data-id="element-1296">
          Publicar las recetas en sitios web o redes sociales sin autorización
        </li>
        <li data-id="element-1297">Usar el contenido con fines comerciales</li>
        <li data-id="element-1298">Modificar y redistribuir el material</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1299">4. Garantía de 30 Días</h3>
      <p className="text-gray-700 mb-4" data-id="element-1300">
        Ofrecemos una garantía de satisfacción de 30 días. Si implementas el
        sistema durante un mes y no estás satisfecho, te devolvemos el 100% de
        tu inversión. Para solicitar un reembolso:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-1301">
        <li data-id="element-1302">
          Envía un email a{' '}
          <a href="mailto:contactomikioscodigital@gmail.com" className="text-baby-blue hover:text-baby-blue-dark transition" data-id="element-1303">
            contactomikioscodigital@gmail.com
          </a>
        </li>
        <li data-id="element-1304">Indica tu número de orden</li>
        <li data-id="element-1305">El reembolso se procesará en 5-7 días hábiles</li>
      </ul>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1306">
        5. Descargo de Responsabilidad
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-1307">Los resultados pueden variar según:</p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-1308">
        <li data-id="element-1309">La consistencia de implementación del sistema</li>
        <li data-id="element-1310">Habilidades culinarias previas</li>
        <li data-id="element-1311">Disponibilidad de ingredientes en tu región</li>
        <li data-id="element-1312">Equipamiento de cocina disponible</li>
      </ul>
      <p className="text-gray-700 mb-4" data-id="element-1313">
        Las recetas están diseñadas para personas sin restricciones alimentarias
        graves. Si tienes alergias o condiciones médicas específicas, consulta
        con un profesional de la salud antes de implementar cambios en tu dieta.
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1314">6. Propiedad Intelectual</h3>
      <p className="text-gray-700 mb-4" data-id="element-1315">
        Todo el contenido del Sistema 50 Recetas Express está protegido por
        derechos de autor. Nos reservamos todos los derechos sobre el material.
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1316">7. Modificaciones</h3>
      <p className="text-gray-700 mb-4" data-id="element-1317">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios serán notificados a través de email y actualizados
        en esta página.
      </p>

      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-1318">8. Contacto</h3>
      <p className="text-gray-700 mb-4" data-id="element-1319">
        Para consultas sobre estos términos:
        <br data-id="element-1320" />
        <strong data-id="element-1321">Email:</strong>{' '}
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-baby-blue hover:text-baby-blue-dark transition" data-id="element-1322">
          contactomikioscodigital@gmail.com
        </a>
        <br data-id="element-1323" />
        <strong data-id="element-1324">Soporte:</strong>{' '}
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-baby-blue hover:text-baby-blue-dark transition" data-id="element-1325">
          contactomikioscodigital@gmail.com
        </a>
      </p>
    </div>;
}